__turbopack_context__.v({
  "circle": "Y8ofmW_circle",
  "slideInAnimation": "Y8ofmW_slideInAnimation",
  "tag": "Y8ofmW_tag",
});
